import Box from '@mui/material/Box';
import { useState } from 'react';
import Header from './Header';
import SideDrawer from './SideDrawer';

const DashboardLayout = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(true);
  const handleToggleSidebar = () => setOpen((prev) => !prev);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', background: '#151A23' }}>
      <SideDrawer open={open} />
      <Box sx={{ flexGrow: 1, minHeight: '100vh', background: '#151A23' }}>
        <Header open={open} onToggleSidebar={handleToggleSidebar} />
        <Box sx={{ pt: 1 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout; 